import React from 'react';

const PickupProgress = ({ monthlyPickup }) => {
    // Calculate total to find percentages
    const total = monthlyPickup.reduce((acc, curr) => acc + curr.value, 0);

    // Color mapping for elegant design
    const colorMap = {
        'PENDING': '#f39c12',
        'RECEIVED': '#2ecc71',
        'ASSIGNED': '#4a90e2'
    };

    return (
        <div className="pickup-progress-container h-100 d-flex flex-column justify-content-center px-4">
            {monthlyPickup.map((item, index) => {
                const percentage = total > 0 ? Math.round((item.value / total) * 100) : 0;
                const barColor = colorMap[item.label] || '#95a5a6';

                return (
                    <div key={index} className="mb-4">
                        <div className="d-flex justify-content-between align-items-end mb-2">
                            <span className="pickup-progress-label">{item.label}</span>
                            <span className="pickup-progress-count">
                                {item.value} <small className="text-muted">({percentage}%)</small>
                            </span>
                        </div>
                        <div className="progress pickup-progress-bar-bg" style={{ height: '12px', borderRadius: '10px' }}>
                            <div 
                                className="progress-bar" 
                                role="progressbar" 
                                style={{ 
                                    width: `${percentage}%`, 
                                    backgroundColor: barColor,
                                    borderRadius: '10px',
                                    transition: 'width 1s ease-in-out'
                                }} 
                                aria-valuenow={percentage} 
                                aria-valuemin="0" 
                                aria-valuemax="100"
                            ></div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PickupProgress;
